import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeZeroDecimals' })
export class RemoveZeroDecimalsPipe implements PipeTransform {
  transform(value: string): string {
    // Convert the value to a string
    const stringValue: string = value.toString();

    // Check if the string has decimals
    if (stringValue.includes('.')) {
      // Split the string at the decimal point
      const parts: string[] = stringValue.split('.');

      // If there are decimals and all of them are zero, remove them
      if (parts.length === 2 && /^[0.]+$/.test(parts[1])) return parts[0];
    }

    // Return the original value if it doesn't have trailing zeros
    return value;
  }
}
